module.exports = __webpack_public_path__ + "img/student_13.a6ec44ae.png";